import { Card, Group, SimpleGrid } from '@mantine/core';
import React, { useContext, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import Maps from '../../components/elements/Maps';
import { AppContext } from '../../contexts';
import {
  fetchActivatedMerchantDetail,
} from './actions';
import styles from './styles.scoped.css';
import GridCell from '../../components/elements/GridCell/GridCell';

function DetailSetting() {
  const { id } = useParams();
  // const navigate = useNavigate();
  const dispatch = useDispatch();
  const { setBreadcrumbs } = useContext(AppContext);
  const {
    detail: { data },
  } = useSelector((state) => state.myptmActivation);
  const centerPoint = {
    lat: parseFloat(data?.coordinate?.split(',')[0]),
    lng: parseFloat(data?.coordinate?.split(',')[1]),
  };

  useEffect(() => {
    setBreadcrumbs(['Data Pangkalan LPG 3 Kg']);
    dispatch(fetchActivatedMerchantDetail(id));
  }, []);

  return (
    <div>
      <div className={styles.cardTitle}>
        <h5>{data.storeName}</h5>
      </div>
      <Card px="0" radius="lg" withBorder>
        <Card.Section className={styles.card__header}>
          <p className={styles.sectionTitle}>Data Pangkalan LPG 3 Kg</p>
        </Card.Section>
        <SimpleGrid className={styles.section} cols={2}>
          <div className={styles.cells}>
            <GridCell data={data.registrationDate} label="Tanggal Registrasi" />
            <GridCell data={data.registrationTime} label="Jam Registrasi" />
            <GridCell
              data={`${data.agen?.id || ''} - ${data.agen?.name || ''}`}
              label="ID Agen"
            />
            <GridCell data={data.midMap} label="MID" />
            <GridCell data={data.midLA} label="MID LinkAja" />
          </div>
          <div className={styles.cells}>
            <GridCell data={data.ownerName} label="Nama Pemilik" />
            <GridCell data={data.nationalityId} label="No. KTP Pemilik" />
            <GridCell data={data.phoneNumber} label="No. Ponsel Pemilik" />
            <GridCell
              data={data.storePhoneNumber}
              label="No. Telepon Pangkalan LPG 3 Kg"
            />
            <GridCell data={data.email} label="Email Pemilik" />
          </div>
        </SimpleGrid>
        <Card.Section className={styles.card__header}>
          <p className={styles.sectionTitle}>Alamat Pangkalan LPG 3 Kg</p>
        </Card.Section>
        <SimpleGrid className={styles.section} cols={2}>
          <div className={styles.cells}>
            <GridCell data={data.provinceName} label="Provinsi" />
            <GridCell data={data.cityName} label="Kota/Kabupaten" />
            <GridCell data={data.districtName} label="Kecamatan" />
            <GridCell data={data.villageName} label="Kelurahan" />
          </div>
          <div className={styles.cells}>
            <GridCell data={data.zipcode} label="Kode Pos" />
            <GridCell data={data.street} label="Alamat" />
          </div>
        </SimpleGrid>
        <Card.Section className={styles.card__header}>
          <p className={styles.sectionTitle}>Rekening Bank</p>
        </Card.Section>
        <SimpleGrid className={styles.section} cols={2}>
          <div className={styles.cells}>
            <GridCell data={data.bank?.bankName} label="Nama Bank" />
            <GridCell data={data.bank?.accountNumber} label="Nomor Rekening" />
            <GridCell
              data={data.bank?.accountName}
              label="Nama Pemilik Rekening"
            />
          </div>
        </SimpleGrid>
      </Card>
      <Card mt="lg" radius="lg" withBorder>
        <Card.Section inheritPadding py="md">
          <Group position="apart">
            <p className={styles.mapTitle}>Titik Koordinat</p>
            <p>{data?.coordinate}</p>
          </Group>
        </Card.Section>
        <div style={{ height: '300px' }}>
          <Maps centerPoint={centerPoint} />
        </div>
      </Card>
    </div>
  );
}

export default DetailSetting;
